import Vue from 'vue';
import PhishingCheck from '../../components/PhishingCheck/PhishingCheck.vue';
import initApplicationGlobal from '../Global/Global';

export default function initApplicationPhishingCheckPage(eventHub) {
  initApplicationGlobal(eventHub);

  new Vue({
    ...PhishingCheck,
  }).$mount('.phishing-check');
}
